import { HttpClient } from '../../../shared/api/httpClient';
import { API_ENDPOINT } from '../../../shared/constanst/constants';
import { AxiosPromise } from 'axios';

const API_SLUG = 'Adjuntos';

export interface Adjunto{
	idAdjunto: number;
	nombre: string;
	tipo: number;
	tamaño?:number;
}

export interface AdjuntoExpatriado{
	idAdjunto: number;
	nombre: string;
	adjunto: any;
	tipo: string;
	longitud: number;
}


export interface TipoAdjunto{
	idTipoAdjunto: number;
	descripcion: string;
}

export interface DeleteAdjunto{
	idParte: number, 
	idAdjunto: number, 
	todosPartes: boolean
}

export class AdjuntosAdapter {
	private cliente: HttpClient;

	constructor() {
		this.cliente = new HttpClient(API_ENDPOINT, API_SLUG);
	}

	ListarAdjuntos(idParte: number): AxiosPromise<Adjunto[]> {
		return this.cliente.get(`/ListarAdjuntos/${idParte}`);
	}

	GetTamañosAdjuntos(idsPartes:number[]): AxiosPromise<boolean> {
		return this.cliente.post(idsPartes, `/GetTamañosAdjuntosPartes`);
	}

	ListarAdjuntosExpatriado(idEmpleado: number): AxiosPromise<AdjuntoExpatriado[]> {
		return this.cliente.get(`/ListarAdjuntosExpatriado/${idEmpleado}`);
	}

	ListarTiposAdjunto(): AxiosPromise<TipoAdjunto[]> {
		return this.cliente.get(`/ListarTiposAdjunto`);
	}
	
	DescargarAdjunto(idAdjunto: number): AxiosPromise<any> {
		return this.cliente.getFile(`/DescargarAdjunto/${idAdjunto}`);
	}

	DescargarAdjuntos(filtro:any): AxiosPromise<any> {
		return this.cliente.postDownloadFile(filtro,`/DescargarAdjuntos`);
	}

	DescargarAdjuntoExpatriado(idAdjunto: number, idEmpleado: number): AxiosPromise<any> {
		return this.cliente.getFile(`/DescargarAdjuntoExpatriado/${idAdjunto}/${idEmpleado}`);
	}

	DescargarAdjuntoHistoricoExpatriado(dataRequest:any): AxiosPromise<any> {
		return this.cliente.postDownloadFile(dataRequest,`/DescargarAdjuntoHistoricoExpatriado`);
	}

	DescargarTodosAdjuntosHistoricoExpatriado(dataRequest:any): AxiosPromise<any> {
		return this.cliente.postDownloadFile(dataRequest,`/DescargarTodosAdjuntosHistoricoExpatriado`);
	}

	EliminarAdjuntos(data: DeleteAdjunto): AxiosPromise<boolean> {
		return this.cliente.post(data, `/DeleteAdjuntos`);
	}

	ModificarTipoAdjunto(data: any): AxiosPromise<boolean> {
		return this.cliente.put(data.IdAdjunto, {IdTipoAdjunto:data.IdTipoAdjunto}, `/ModificarTipoAdjunto`);
	}
}